import { env } from './EnvironmentCondig'

export const APP_NAME = 'Ip.Call Go Public';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const HOST_URL =env.HOST_URL
export const HOST =env.HOST
export const STATIC_FOLDER = env.STATIC_ENDPOINT_URL
export const GOOGLE_API_CLIENT_ID = env.GOOGLE_API_CLIENT_ID
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/home`;
export const UNAUTHENTICATED_ENTRY = '/login'
export const MAIL_BASE_URL =env.MAIL_BASE_URL;
